// import GoonerVideo from '../../assets/videos/gooner-insanity.mov';
// import BitchVideo from '../../assets/videos/making-you-my-bitch.mov';
// import DontLookVideo from '../../assets/videos/dont-look-away.mov';
// import ServeQueenVideo from '../../assets/videos/serve-queen.mov';
// import MuscleVideo from '../../assets/videos/weak-for-muscles.mov';
// New
import DeliciousDenial from '../../assets/videos/queen-blaire-dominatrix-clips-delicious-denial.mov';
import FuckedBy from '../../assets/videos/queen-blaire-dominatrix-clips-fucked-by-msucle-goddess.mov';
import MoreProtien from '../../assets/videos/queen-blaire-dominatrix-clips-more-protien.mov';
import NoEscape from '../../assets/videos/queen-blaire-dominatrix-clips-no-escape.mov';
import CockOwner from '../../assets/videos/queen-blaire-dominatrix-clips-owns-your-cock.mov';
import MyWallet from '../../assets/videos/queen-blaire-dominatrix-clips-youre-my-wallet.mov';

export const videoDataArray = [
  // {
  //   videoUrl: GoonerVideo,
  //   title: 'Gooner Insanity',
  //   description:
  //     'If you’re a gooner perv and you love being mindfucked, this is the clip for you. I want to watch you go insane for Me. I’ll give you a longgg 10 second countdown for the first 10 minutes and I expect you to ruin your orgasm when I get to 1. Right after, you’re gonna eat your cum and continue stroking to Me, watching Me touch Myself and teasing you with the thought of tasting Me. And the end, you’ll cum for Me again, emptying those gooner balls BUT I want you to keep watching this clip over and over and over again until there’s nothing left in them.',
  // },
  // {
  //   videoUrl: BitchVideo,
  //   title: 'Making you My bitch',
  //   description:
  //     'I’ve seen you staring at Me in class, drooling over My muscles. you’re such a loser! I’m gonna humiliate you today, weak bitch. Watch as I flex in front of you, mocking your tiny muscles and showing off My strength. The second half I’m gonna grab you by the throat and lift you up with one arm, laughing at you and switching arms with ease. Nothing you can do about it other than submit! I’m gonna make you My bitch today, you pathetic weak loser! Getting lifted by Me makes you so hard and I decide to jack you off while holding you in the air, a dream come true for a horny weak bitch like you!',
  // },
  // {
  //   videoUrl: DontLookVideo,
  //   title: 'Don’t look away',
  //   description:
  //     'I’ll take ownership of you, eye to eye, while pleasuring Myself offscreen. Appreciate and worship My perfect face while you goon on your knees, edging and licking up your leakage. At the end, I’ll make you clean up both of O/our messes.',
  // },
  // {
  //   videoUrl: ServeQueenVideo,
  //   title: 'Serve Queen Blaire',
  //   description:
  //     'This position with My feet up and touching My pussy makes you so weak. you will kneel and worship while I rub My clit over My panties, explaining to you how I’d use your tongue for My pleasure. Instead of letting you lick My pussy, I’m gracious enough to let you kiss and lick My pretty feet. I won’t let you stroke until the last half of the clip and even then, it’s only for the purpose of eating your load for My amusement. I will use you as I see fit, gooner.',
  // },
  // {
  //   videoUrl: MuscleVideo,
  //   title: 'Weak for muscles',
  //   description:
  //     'I want you on your knees, worshipping My tight, strong body during this entire clip. you are not allowed to stroke. I’ll be rubbing oil all over My muscles and you’re gonna enjoy every inch of Me. Such a lucky weakling!',
  // },
    {
    videoUrl: DeliciousDenial,
    title: 'Delicious Denial',
    description:
      'You’re either going to put a chastity cage on or not touch your cock for this entire clip. I expect you to kneel and keep your hands behind your back as I tease you hard. Focus on Me, focus on My pleasure, that’s what a good boy does. I have one more rule but you’ll have to buy the clip to find out.',
  },
    {
    videoUrl: FuckedBy,
    title: 'Fucked by a Muscle Goddess',
    description:
      'I caught you being a perv in the gym, watching Me and other hot, strong women workout. I know you go into the gym just to watch Us and then go home to jerk, thinking about fucking Us. Well, that will never happen because you’re a weak, disgusting bitch. I decided it’s time to put you in your place and fuck you the way you deserve to be fucked. Open your mouth, get My cock wet. Next, you’ll be getting on all fours and spreading your cheeks for My big cock. you’ll be sore tomorrow but it won’t be from working out.',
  },
  {
    videoUrl: CockOwner,
    title: 'I Own Your Cock',
    description:
      'Queen Blaire owns your cock - I own your cock… plain and simple. you are Mine. I want you to forget the outside world and focus just on Me. I’ll be instructing you on how to stroke while teasing you with My oiled up bikini bod and I expect you to follow along like a good boy.',
  },
  {
    videoUrl: NoEscape,
    title: 'No Escape',
    description:
      'Kneel, worship, obey… those are the 3 words that you need to remember. I’m going to lock you up in My cage and train you on how to be a good slave. There’s no escaping this.. you were always meant to be a submissive toy and it feels so good to be used. I’ll let you stroke near the end with a cum countdown and CEI.',
  },
  {
    videoUrl: MoreProtien,
    title: 'More Protein',
    description:
      'I know how badly you wish you had muscles like Mine. Luckily, I have a solution for you.. all you need to do is eat more protein and what better way to do that than to eat your cum for Me. Admire My muscles as I give you a cum countdown. Get into the loser position, hips above your head, giving yourself a facial when you explode and licking up every drop.',
  },
  {
    videoUrl: MyWallet,
    title: "You're My Wallet",
    description:
      'You love nothing more than stroking and sending your cash to a beautiful Goddess. I know just how to tease you into sending everything, mind fucking you into being a good wallet for Me. Follow along as I instruct you on how to jerk while making sure your wallet is properly fucked.',
  },

];
